angular.module('taric.model.measureReport',['common.helper', 'ngResource']).factory('QueryMeasureReport', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/report/measures', {}, {
        querySecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/report/measures'
        }
    });
}).service('MeasureReportModel', function($q, $translate, CONSTANTS, CommonHelper, QueryMeasureReport, AuthorizeModel){
    var model = this;
    var searchCriteria = null;
    var searchResult = null;

    model.getSearchCriteria = function (){
        return searchCriteria;
    };
    model.resetSearchCriteria = function(){
        searchCriteria = {};
        searchCriteria.startDate = new Date();
        searchCriteria.endDate = null;
        searchCriteria.commodityCodeRangeStart = null;
        searchCriteria.commodityCodeRangeEnd = null;
        searchCriteria.direction = 'B';
        searchCriteria.country = null;
        searchCriteria.measureType = null;
        searchCriteria.measureTypes = [];
        searchCriteria.additionalCode = null;
        searchCriteria.additionalCodes = [];
        searchCriteria.footnote = null;
        searchCriteria.footnotes = [];
        searchCriteria.certificate = null;
        searchCriteria.certificates = [];
        searchCriteria.goodsNomenclatureDescription = false;
        searchCriteria.additionalCodeDescription = false;
        searchCriteria.footnoteDescription = false;
        searchCriteria.certificateDescription = false;
        searchCriteria.geographicalAreaDescription = false;
        searchCriteria.dutyExpressionDescription = false;
        searchCriteria.ascending = true;

        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.getSearchResult = function (){
        return searchResult;
    };
    model.resetSearchResult = function(){
        searchResult = null;
    };

    model.reset = function () {
        model.resetSearchCriteria();
        model.resetSearchResult();
    };
    model.reset();

    model.searchMeasureReport = function(page, exportType){
        var deferred = $q.defer();
        
        if (model.loggedIn) {
            var options = {
                startDate: CommonHelper.getRestDateString(searchCriteria.startDate),
                endDate: CommonHelper.getRestDateString(searchCriteria.endDate),
                commodityCodeRangeStart: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeStart),
                commodityCodeRangeEnd: CommonHelper.removeSpaceCharacters(searchCriteria.commodityCodeRangeEnd),
                tradeDirection: searchCriteria.direction === 'I' || searchCriteria.direction === 'E' ? searchCriteria.direction : null,
                country: searchCriteria.country, 
                measureTypes: CommonHelper.getDistinctCodeList(searchCriteria.measureTypes, searchCriteria.measureType),
                additionalCodes: CommonHelper.getDistinctCodeList(searchCriteria.additionalCodes, searchCriteria.additionalCode),
                footnotes: CommonHelper.getDistinctCodeList(searchCriteria.footnotes, searchCriteria.footnote),
                certificates: CommonHelper.getDistinctCodeList(searchCriteria.certificates, searchCriteria.certificate),
                goodsNomenclatureDescription: searchCriteria.goodsNomenclatureDescription,
                additionalCodeDescription: searchCriteria.additionalCodeDescription,
                footnoteDescription: searchCriteria.footnoteDescription,
                certificateDescription: searchCriteria.certificateDescription,
                geographicalAreaDescription: searchCriteria.geographicalAreaDescription,
                dutyExpressionDescription: searchCriteria.dutyExpressionDescription,
                sortOrder: searchCriteria.ascending ? 'A' : 'D',
                sortColumn: searchCriteria.sortCol,
                language: CommonHelper.getLanguageCode($translate.use()),
                exportType: exportType
            };

            if (page) {
                options.offset = CommonHelper.getOffset(page);
                options.count = CONSTANTS.rowsPerPage;
            }

            var result = QueryMeasureReport.querySecure(options, function () {
                var returnedResult = {};
                returnedResult.totalItems = result.count;
                returnedResult.items = result.items;
                returnedResult.currentPage= page;

                if (searchCriteria.goodsNomenclatureDescription && result.goodsNomenclatureDescriptions && result.goodsNomenclatureDescriptions.length > 0) {
                    returnedResult.goodsNomenclatures = result.goodsNomenclatureDescriptions;
                }
                if (searchCriteria.additionalCodeDescription && result.additionalCodeDescriptions && result.additionalCodeDescriptions.length > 0) {
                    returnedResult.additionalCodes = result.additionalCodeDescriptions;
                }
                if (searchCriteria.footnoteDescription && result.footnoteDescriptions && result.footnoteDescriptions.length > 0) {
                    returnedResult.footnotes = result.footnoteDescriptions;
                }
                if (searchCriteria.certificateDescription && result.certificateDescriptions && result.certificateDescriptions.length > 0) {
                    returnedResult.certificates = result.certificateDescriptions;
                }
                if (searchCriteria.geographicalAreaDescription && result.geographicalAreaDescriptions && result.geographicalAreaDescriptions.length > 0) {
                    returnedResult.geographicalAreas = result.geographicalAreaDescriptions;
                }

                angular.forEach(returnedResult.items, function (measure) {
                    if (measure.excludedCountryIds.length > 0) {
                        measure.excludedCountryIds = measure.excludedCountryIds.join(" ");
                    } else {
                        measure.excludedCountryIds = '';
                    }
                    var orderNumber = measure.orderNumber;
                    if (orderNumber) {
                        // Use regexp to compare with orderNumber
                        var regexp = new RegExp(CONSTANTS.licenseQuotaPattern);
                        measure.licenseQuota = regexp.test(orderNumber);
                    } else {
                        measure.licenseQuota = false;
                    }
                });

                if (page){
                    searchResult = returnedResult;
                }

                deferred.resolve(returnedResult);
            }, function(error){
                deferred.reject(error);
            });

        } else {
            var error = {};
            error.data = {};
            error.data.code = 'i8n.bl.unauthenticated';
            error.data.params = null;
            error.data.type = 'ERROR';
            deferred.reject(error);
        }

        return deferred.promise;
    };

});


// WEBPACK FOOTER //
// ./app/taric/report/measure/measure-report-model.js